import Client from '../client';
import {flattenObject} from '../helpers';
import {
  CreatePackagesRequestBuilder,
  ExportPackagesFileRequestBuilder,
  GetAllPackagesRequestBuilder,
  GetAllSuggestedPackagesforOrder,
  GetPackagesCountRequestBuilder,
  UpdatePackageRequestBuilder,
  UpdatePackageStatusesRequestBuilder,
  GetPackagesCountOrdersRequestBuilder,
  GetPackageReportOrderListRequestBuilder,
  GetAllPackageTypesRequestBuilder,
} from '../package-management/packageManagement';

const token = localStorage.getItem('token') || '';

class PackageManagementRepository {
  getPackages = async (actions: any) => {
    const makePackagesRequest = new GetAllPackagesRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const makecountRequest = new GetPackagesCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makePackagesRequest);
    const count = await client.execute(makecountRequest);

    return {response, count};
  };

  getPackagesExcel = async (actions: any) => {
    const makePackagesRequest = new GetAllPackagesRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makePackagesRequest);

    return response;
  };

  createPackages = async (actions: any) => {
    const makePackagesRequest = new CreatePackagesRequestBuilder()
      .data(flattenObject({...actions.payload}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makePackagesRequest);

    return response;
  };

  getSinglePackage = async (actions: any) => {
    const makePackageRequest = new GetAllPackagesRequestBuilder()
      .id(actions.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makePackageRequest);

    return response;
  };

  updatePackages = async (actions: any) => {
    const makePackagesRequest = new UpdatePackageRequestBuilder()
      .data(flattenObject({...actions.payload}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makePackagesRequest);

    return response;
  };

  updateStatus = async (actions: any) => {
    const makePackageRequest = new UpdatePackageStatusesRequestBuilder()
      .id(actions.id)
      .data(actions.payload)
      .build();
    const client = new Client(token);
    const response = await client.execute(makePackageRequest);

    return response;
  };

  getAllSuggestedPackages = async (actions: any) => {
    const makePackageRequest = new GetAllSuggestedPackagesforOrder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makePackageRequest);
    return response;
  };

  //v1.29+
  getPackageCountOrders = async (actions: any) => {
    const makePackageRequest = new GetPackagesCountOrdersRequestBuilder()
    .data(actions.id)
    .params(actions.params)
    .build();
    const client = new Client(token);
    const response = await client.execute(makePackageRequest);
    return response;
  };

  getPackageReportOrderList = async (actions: any) => {
    const makePackageRequest = new GetPackageReportOrderListRequestBuilder()
    .id(actions.id)
    .params(actions.params)
    .build();
    const client = new Client(token);
    const response = await client.execute(makePackageRequest);
    return response;
  }

  getAllPackageTypes = async (actions: any) => {
    // console.log("Actions from pack types req:",actions)
    const makePackageRequest = new GetAllPackageTypesRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makePackageRequest);
    return response;
  }
}

export default new PackageManagementRepository();
